import React, {Component} from 'react';
import {
  StyleSheet,
  Text,
  View,
  Image,
  TouchableOpacity,
  Dimensions,
} from 'react-native';
import PropTypes from 'prop-types';
import colors from '../HelperClasses/AppColor';
import tableStyle from '../StyleSheets/TableCommonStyleSheet';
import {Gradient} from 'react-gradient';
import {ReactComponent as LockIcon} from '../assets/lockWhite.svg';
import {ThemeContext} from '../HelperClasses/ThemeContext';
import LocaleContext from '../Localization/LocaleContext';
import RolePermissionContext from './RolePermissionContext';

export default class SaveButton extends Component {
  static contextType = ThemeContext;
  static propTypes = {
    saveBtn: PropTypes.func,
    saveBtnTitle: PropTypes.node,
    showSaveBtn: PropTypes.bool,
    btnDeActive: PropTypes.bool,
    showLock: PropTypes.bool,
    deActiveBtnAction: PropTypes.func,
  };
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }
  renderActiveBtn = ({translate = key => key, disabled = false} = {}) => {
    const themeColors = this.context?.colors ?? colors;
    const gradients = this.context?.isDark
      ? [['#195c52', '#26796e'], ['#195c52', '#26796e']]
      : themeColors.GradientColors;
    let saveTitle =
      this.props.saveBtnTitle == undefined ? 'Save' : this.props.saveBtnTitle;
    if (typeof saveTitle === 'string') saveTitle = translate(saveTitle);
    if (this.props.showSaveBtn == undefined || this.props.showSaveBtn == true) {
      return (
        <View>
          <View style={tableStyle.gradientViewBGStyle}>
            <Gradient
              gradients={gradients} // required
              property="background"
              gradientType={'linear'}
              duration={2333000}
              angle="0deg">
              <TouchableOpacity onPress={this.props.saveBtn} disabled={disabled} style={{opacity: disabled ? 0.55 : 1}}>
                <Text style={tableStyle.saveBtnTxtStyle}>{saveTitle}</Text>
              </TouchableOpacity>
            </Gradient>
          </View>
        </View>
      );
    } else {
      return <View />;
    }
  };
  renderDeActiveBtn = ({translate = key => key, disabled = false} = {}) => {
    let saveTitle =
      this.props.saveBtnTitle == undefined ? 'Save' : this.props.saveBtnTitle;
    if (typeof saveTitle === 'string') saveTitle = translate(saveTitle);
    if (this.props.showSaveBtn == undefined || this.props.showSaveBtn == true) {
      return (
        <View>
          <View style={tableStyle.gradientViewBGStyle}>
            <Gradient
              gradients={colors.GradientGrayColors} // required
              property="background"
              gradientType={'linear'}
              duration={2333000}
              angle="0deg">
              <TouchableOpacity
                style={{flexDirection: 'row', alignItems: 'center', opacity: disabled ? 0.55 : 1}}
                onPress={this.props.deActiveBtnAction}
                disabled={disabled}>
                {this.props.showLock && (
                  <LockIcon
                    stroke={colors.AppWhite}
                    style={{height: 16, width: 16, marginLeft: 8}}
                  />
                )}
                <Text style={tableStyle.saveBtnTxtStyle}>{saveTitle}</Text>
              </TouchableOpacity>
            </Gradient>
          </View>
        </View>
      );
    } else {
      return <View />;
    }
  };
  render() {
    return (
      <RolePermissionContext.Consumer>
        {permission => (
          <LocaleContext.Consumer>
            {localeContext => this.props.btnDeActive == true
              ? <this.renderDeActiveBtn translate={localeContext?.translate} disabled={permission?.writeP === false} />
              : <this.renderActiveBtn translate={localeContext?.translate} disabled={permission?.writeP === false} />}
          </LocaleContext.Consumer>
        )}
      </RolePermissionContext.Consumer>
    );
  }
}
